<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
     color: '#6c757d',
     order_by: '',
     show_reminder_popup: false,
     is_upload_document: false,
    };
  },
  methods: {
   add(){
    this.resetForm();
   },
   editStage(stage) {
    this.id = stage.id;
    this.name = stage.name;
    this.color = stage.color;
    this.order_by = stage.order_by;
    this.show_reminder_popup = !!stage.show_reminder_popup;
    this.is_upload_document = !!stage.is_upload_document;
   },  

   async addUpdateStage(){
    this.errors = {};
    this.setLoading(true); 

    try{
      const payload = {
       id: this.id, 
       name: this.name,
       color: this.color,
       order_by: this.order_by,
       show_reminder_popup: this.show_reminder_popup ? 1 : 0,
       is_upload_document: this.is_upload_document ? 1 : 0,
      };
      let response = {};
      if(this.id){
      //UPDATE
      response = await axios.put(`/lead-stages/update`, payload);
     }else{
      //CREATE
      response = await axios.post(`/lead-stages/create`, payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.$emit('saved'); 
     this.closeModal('stage_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteStage(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/lead-stages/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
    this.closeModal('delete_modal');
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.color = '#6c757d';
   this.errors = {};
   this.show_reminder_popup = false;
   this.is_upload_document = false;
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="stage_modal">
  <div class="modal-dialog modal-dialog-centered modal-mg w-100">
  <div class="modal-content">
   <div class="modal-header">
    <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Stage</h4>
    <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
     <i class="ti ti-x"></i>
    </button>
    </div>
    <form @submit.prevent="addUpdateStage">
     <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Stage Name</label>
            <input type="text" class="form-control" v-model="name" />
            <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label class="form-label">Color Code</label>
            <input type="color" class="form-control form-input-color" v-model="color" />
            <div v-if="errors.color" class="text-danger small mt-1">{{ errors.color[0] }}</div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label class="form-label">Order</label>
            <input type="number" class="form-control form-input-color" v-model="order_by" min="0" />
            <div v-if="errors.order_by" class="text-danger small mt-1">{{ errors.order_by[0] }}</div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <input type="checkbox" class="me-1" v-model="show_reminder_popup" id="show_reminder_popup" />
            <label class="form-label" for="show_reminder_popup">Show Reminder Popup?</label>
            <div v-if="errors.show_reminder_popup" class="text-danger small mt-1">{{ errors.show_reminder_popup[0] }}</div>
          </div>
        </div>

        <div class="col-md-6">
        <div class="mb-3">
          <input type="checkbox" class="me-1" v-model="is_upload_document" id="is_upload_document" />
          <label class="form-label" for="is_upload_document">Is Document Upload?</label>
          <div v-if="errors.is_upload_document" class="text-danger small mt-1">{{ errors.is_upload_document[0] }}</div>
        </div>
      </div>
        
      </div>
    </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </form>
  </div>
  </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteStage">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
